// extracted by mini-css-extract-plugin
export default {"body":"ConfirmModal_body__erYGR","message":"ConfirmModal_message__bvaQw","footer":"ConfirmModal_footer__1NaEv"};